export const TeamDetails = [
    {
      name: "Anajani Kumar",
      description: "IT Head",
      img: "/assets/Company/TeamDetail/Anjani.jpeg",
    //   path:"biscuits--cakes"
    },
    {
        name: "Nirbhay Singh",
        description: "Management",
        img: "/assets/Company/TeamDetail/Nirbhay.jpeg",
        // path:"fish--meat"
      },
      {
        name: "Aruna Chauhan",
        description: "Co Founder",
          img: "/assets/Company/TeamDetail/ArunaChauhan.jpeg",
        //   path:"fresh-vegetable"
      },
  ];